import React from 'react';
import Learn5Ps from './Learn5PsTile';
import BookReadingSession from './BookReadingSession';
import ConnectWithSocials from './ConnectWithSocials';

type Props = {
  userId?: number;
  userEmail?: string;
  showEmptySpace?: boolean;
};

const FooterTile: React.FC<Props> = ({ showEmptySpace = false, userId }) => {
  const imgName = 'group-8';

  const handleOnClick = (pageTitle: string, url: string) => {
    const { gtag } = window;
    const urlObj = new URL(url);
    const pathName = urlObj.pathname;

    if (typeof gtag === 'function') {
      gtag('event', 'promo_tile_click', {
        page_title: pageTitle,
        page_location: url,
        page_path: pathName,
        event_category: pageTitle,
        event_label: `${pageTitle} ${userId}`,
        send_to: process.env.REACT_APP_GA_TRACKING_CODE
      });
    }

    window.open(url);
  };

  return (
    <>
      <section className="body-footer--wrapper">
        <Learn5Ps handleOnClick={handleOnClick} />
        <BookReadingSession handleOnClick={handleOnClick} />
        <ConnectWithSocials handleOnClick={handleOnClick} />
        {showEmptySpace && (
          <div className="body-footer--empty-space">
            <img
              alt=""
              src={`../${imgName}.png`}
              srcSet={`../${imgName}.png, ../${imgName}@2x.png 2x, ../${imgName}@3x.png 3x`}
            />
          </div>
        )}
      </section>
    </>
  );
};

export default React.memo(FooterTile);
